
























import Vue from "vue";
import { Component } from "vue-property-decorator";
import { VHeaders, PaginationModel } from "@/models/pagedlistmodel";
import { Response } from "@/models/response";
import { CustomerInfoViewModel } from "@/models/fixedops/repairorder";
import {
  MessageCreateViewModel,
  MessageAttachmentViewModel,
} from "@/models/telephony/message";
import { VFields } from "@/models/v-fields";
import { Template } from "@/models/template";
import {
  ConversationTypes,
  MetadataType,
  MetadataKeyIdentifier,
  TemplateAssociationType,
} from "@/enums/enums";
import { NotificationHelper as _notification } from "@/helper/notifications.helper";
import { Base } from "@/components/common/base";
import { attachmentService, messageService } from "@/shared";
import { getAttachmentHeaders, getSendMessageHeaders } from "./repair.order";

@Component({
  props: ["methodName", "progress"],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import("@/components/common/app.grid.vue"),
    AppDialog: () => import("@/components/common/app.dialog.vue"),
  },
})
export default class SendMessageComponent extends Base {
  public pagedTextLog: any[] = [];
  public pagination = new PaginationModel("name");

  public headers: VHeaders[] = [
    {
      align: "left",
      text: this.$parent.$t("sendMessage.rOSendMessageGrid.date") as string,
      value: "createdAt",
      fieldType: "date",
    },
    {
      align: "left",
      text: this.$parent.$t("sendMessage.rOSendMessageGrid.from") as string,
      value: "messageJson.from",
    },
    {
      align: "left",
      text: this.$parent.$parent.$t(
        "sendMessage.rOSendMessageGrid.to"
      ) as string,
      value: "messageJson.to",
    },
    {
      align: "left",
      text: this.$parent.$parent.$t(
        "sendMessage.rOSendMessageGrid.message"
      ) as string,
      value: "messageJson.textJson.body",
    },
    {
      text: "Sentiment",
      align: "left",
      value: "messageJson.customerSentiment",
      sortable: false,
      fieldType: "template",
      template: (item) => {
        if (
          item.customerSentiment == "positive" ||
          item.customerSentiment == "Positive"
        ) {
          return `<span style="color: green">
                  <i
                    class="fa fa-smile-o customer-sentiment-smile-font"
                    aria-hidden="true"
                  ></i>
                </span>`;
        } else if (
          item.customerSentiment == "negative" ||
          item.customerSentiment == "Negative"
        ) {
          return ` <span style="color: red">
                  <i
                    class="fa fa-frown-o customer-sentiment-smile-font"
                    aria-hidden="true"
                  ></i>
                </span>`;
        } else if (
          item.customerSentiment == "neutral" ||
          item.customerSentiment == "Neutral"
        ) {
          return ` <span style="color: grey">
                  <i
                    class="fa fa-meh-o customer-sentiment-smile-font"
                    aria-hidden="true"
                  ></i>
                </span>`;
        }
      },
    },
  ];

  public loading: boolean = false;
  public constants: any = {
    customerKey: "",
    recordKey: "0",
    customerPhoneNumber: "",
  };

  public templates: Template[] = [];
  public customerInfo: CustomerInfoViewModel = {};
  public messageToSend: MessageCreateViewModel = new MessageCreateViewModel(
    ConversationTypes[ConversationTypes.Text]
  );
  public attachmentAction: any[] = [];
  public customerPhoneNumber: string = "";
  public customerSentiment: string = "";
  public backPreCsiDashboard : boolean = false;

  public beforeDestroy() {
    const buttons = [];
    this.$emit("updateToolBar", buttons);
  }
  public callMethod(methodName): void {
    if ( methodName === "PreCsiDashboard") {
      this.$router.push({ name: "dashboard.precsifollowup.dashboard" });
    }else if (methodName === "backToList" ) {
        this.$router.push({ name: "app.repairorders.closed" });
    } else if (methodName === "refresh") {
      this.getExistingMessages();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== "") {
      this.$emit("resetMethodName", methodName);
    }
  }

  public updateToolBar(): void {
    const buttons: any = [];
    if(!this.backPreCsiDashboard){
      buttons.push({
        id: "0",
        type: "button",
        title: this.$t("sendMessage.btnROList"),
        disabled: false,
        visible: true,
        class: "btn",
        label: this.$t("sendMessage.btnROList"),
        click: "backToList",
        icon: "fas fa-arrow-left",
      });
    }

    if(this.backPreCsiDashboard){

      buttons.push({
        id: "1",
        type: "button",
        title: "Pre Csi Dashboard",
        disabled: false,
        visible: true,
        class: "btn",
        label: "Pre Csi Dashboard",
        click: "PreCsiDashboard",
        icon: "fas fa-arrow-left",
      });
    }

      buttons.push({
        id: "2",
        type: "button",
        title: "Refresh",
        disabled: false,
        visible: true,
        class: "btn",
        label: "Refresh",
        click: "refresh",
        icon: "fa fa-refresh",
      });
    this.$emit("updateToolBar", buttons);
    }

  public mounted() {
    // activating tab
    this.$root.$emit("sidebar.layout.vue", "customerSearch");

    const constKeys = Object.keys(this.constants);
    constKeys.forEach((key) => {
      if (this.$route.query[key]) {
        this.constants[key] = ((this.$route.query[key] as string) || "").trim();
      }
    });

    if (
      this.constants?.customerPhoneNumber &&
      this.constants?.customerPhoneNumber != ""
    ) {
      this.customerPhoneNumber = this.constants?.customerPhoneNumber;
    }

  

    this.messageToSend.recordIdentifier = this.$route.params.type;
    this.messageToSend.recordKey = this.constants.recordKey;
    if(this.$route.query.backScreenName){
          this.backPreCsiDashboard = true;
    }else{
      this.backPreCsiDashboard = false;
    }

      // Toolbar
      this.updateToolBar();
    this.$watch("methodtoCall", (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.attachmentAction = [
      {
        type: "button",
        icon: "fa fa-eye",
        title: this.$parent.$t(
          "sendMessage.rOAttachmentDetailGrid.gridActions.viewAttachment"
        ) as string,
        action: (model: any) => {
          attachmentService.viewAttachmentAsync(model.attachmentId);
        },
      },
    ];
    this.getExistingMessages();
  }

  public async getExistingMessages(): Promise<void> {
    if (this.constants.customerKey && this.messageToSend.recordIdentifier) {
      try {
        this.loading = true;
        const response = await messageService.getExistingMessages(
          this.constants.customerKey,
          this.constants.recordKey,
          this.messageToSend.recordIdentifier
        );

        this.pagedTextLog = response.existingMessages.results;
        this.pagination.totalItems = response.existingMessages.results.length;
        // if (response.existingMessages.results.length > 0) {
        //   this.customerSentiment = response.existingMessages.results.find(
        //     (x) => x.messageJson.from == this.customerPhoneNumber
        //   )?.customerSentiment;
        // }
      } finally {
        this.loading = false;
      }
    }
  }

  public updatePaging(paging): void {
    this.pagination = paging;
  }
}
